import { drawingConstant } from "../actionTypes";
import { userService } from "../middlewares/userService";
import { alertActions } from "./alertActions";

export const drawingActions = {
  drawing,
  saveDrawingLayer,
  deleteCurrentDrawingLayer,
  closePopup,
  openPopup,
  recievePolycoord,
  createPolygon,
  updatePolygon,
  editPolygon,
  setPreference,
  updatePreference, // this function is exclusively made to update popup content on create popup over drawing tools
  deletePolygon,
};

// MAP Drawing
function drawing(param) {
  return (dispatch) => {
    if (param?.status === "request") {
      // verified
      let resp = {
        coordinates: param.coord,
        layer: param.layer,
      };
      dispatch(start(resp));
    } else if (param === "completed") {
      dispatch(setAsDefault());
    }
  };

  function start(resp) {
    return { type: drawingConstant.DRAWING_REQUEST, resp };
  }
  function setAsDefault() {
    return { type: drawingConstant.CLOSE_POPUP_DEFAULT };
  }
}

function deleteCurrentDrawingLayer() {
  return (dispatch) => {
    dispatch(processing());
  };
  function processing(value) {
    return { type: drawingConstant.DELETE_DRAWING_LAYER };
  }
}

function saveDrawingLayer(param, layer) {
  return (dispatch) => {
    dispatch(processing({ param, layer }));
  };
  function processing(param) {
    return { type: drawingConstant.SAVE_DRAWING_LAYER, param };
  }
}

// Modal pop up open/close
function closePopup(param) {
  return (dispatch) => {
    if (param === "initialize") {
      dispatch(open());
    } else if (param === "reinitialize") {
      dispatch(close());
    }
  };

  function open() {
    return { type: drawingConstant.CLOSE_POPUP_REQUEST };
  }
  function close() {
    return { type: drawingConstant.CLOSE_POPUP_DEFAULT };
  }
}

function openPopup(param) {
  return (dispatch) => {
    if (param === "default") {
      dispatch(open());
    } else if (param === "close") {
      dispatch(close());
    }
  };
  function open() {
    return { type: drawingConstant.OPEN_POPUP_REQUEST };
  }
  function close() {
    return { type: drawingConstant.OPEN_POPUP_DEFAULT };
  }
}

function setPreference(param) {
  return (dispatch) => {
    dispatch(processing(param));
  };
  function processing(param) {
    return { type: drawingConstant.DRAWING_SET_PREFERENCE, param };
  }
}

function updatePreference(param, layer) {
  return (dispatch) => {
    dispatch(processing({ param, layer }));
  };
  function processing(param) {
    return { type: drawingConstant.DRAWING_UPDATE_PREFERENCE, param };
  }
}
function editPolygon() {
  return (dispatch) => {
    dispatch(change());
  };
  function change(param) {
    return { type: drawingConstant.DRAWING_CHANGE_PREFERENCE };
  }
}

function createPolygon(param) {
  return (dispatch) => {
    dispatch(request());
    userService
      .savePolygon(param.data)
      .then((resp) => {
        dispatch(alertActions.success("Alerts subscribed"));
        dispatch(success(resp));
      })
      .catch((error) => {
        if (error?.response) {
          const resp = error?.response?.data;
          if (resp?.data) {
            error = resp?.data?.message;
          } else {
            error = "Please contact our team for further data and insights";
          }
        } else {
          error = "Please check your internet connection.";
        }
        dispatch(alertActions.error(error));
        dispatch(failure(error));
      });
  };

  function request() {
    return { type: drawingConstant.CREATE_SHAPE_REQUEST };
  }
  function success(resp) {
    return { type: drawingConstant.CREATE_SHAPE_SUCCESS, resp };
  }
  function failure(error) {
    return { type: drawingConstant.CREATE_SHAPE_FAILURE, error };
  }
}

function updatePolygon(param) {
  return (dispatch) => {
    dispatch(request());
    userService
      .editPolygon(param.data)
      .then(async (resp) => {
        // await recievePolycoord();
        dispatch(alertActions.success("Alerts preferences updated"));
        dispatch(success(resp));
      })
      .catch((error) => {
        if (error?.response) {
          const resp = error?.response?.data;
          if (resp?.data) {
            error = resp?.data?.message;
          } else {
            error = "Please contact our team for further data and insights";
          }
        } else {
          error = "Please check your internet connection.";
        }
        dispatch(alertActions.error(error));
        dispatch(failure(error));
      });
  };

  function request() {
    return { type: drawingConstant.UPDATE_SHAPE_REQUEST };
  }
  function success(resp) {
    return { type: drawingConstant.UPDATE_SHAPE_SUCCESS, resp };
  }
  function failure(error) {
    return { type: drawingConstant.UPDATE_SHAPE_FAILURE, error };
  }
}

function deletePolygon(index) {
  return (dispatch) => {
    dispatch(request(index));
    userService
      .deletePolygon(index)
      .then(async (resp) => {
        dispatch(success(resp, index));
      })
      .catch((error) => {
        if (error?.response) {
          const resp = error?.response?.data;
          if (resp?.data) {
            error = resp?.data?.message;
          }
        } else {
          error = "Please check your internet connection.";
          dispatch(alertActions.error(error));
        }
        dispatch(failure(error));
      });
  };

  function request(index) {
    return { type: drawingConstant.DELETE_SHAPE_REQUEST, index };
  }
  function success(resp, index) {
    return { type: drawingConstant.DELETE_SHAPE_SUCCESS, resp, index };
  }
  function failure(error, index) {
    return { type: drawingConstant.DELETE_SHAPE_FAILURE, error, index };
  }
}

function recievePolycoord() {
  return (dispatch) => {
    dispatch(request());
    userService
      .recieve_polygon()
      .then((response) => {
        const resp = response?.data?.data; //next
        const coords = [];
        resp.map((value, index) => {
          coords.push(value.points);
          return null;
        });
        const respData = {
          resp,
          coords,
        };
        dispatch(success(respData));
      })
      .catch((error) => {
        const resp = error?.response?.data;
        // const errorStatus = error?.response?.status;
        if (resp?.data) {
          error = resp?.data?.message;
        }
        dispatch(failure(error));
      });
  };

  function request() {
    return { type: drawingConstant.LOAD_POLYGON_REQUEST };
  }
  function success(response) {
    return { type: drawingConstant.LOAD_POLYGON_SUCCESS, response };
  }
  function failure(error) {
    return { type: drawingConstant.LOAD_POLYGON_FAILURE, error };
  }
}
